export enum MusicLibraryLicenseSetting {
  Disabled = 'disabled',
  Free = 'free',
  PaidHigh = 'paidHigh',
  PaidLow = 'paidLow',
  PaidMid = 'paidMid',
}
